import barba from '@barba/core'
import Lenis from 'lenis'
import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js'
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js'
import Botpoison from '@botpoison/browser'
import { ModuleRegistry, AllCommunityModule, createGrid } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// barba
barba.init({
  debug: false,
  transitions: [{
    name: 'global',
    once() {
      requestAnimationFrame(raf)
      document.querySelector('[data-copyright-year]').textContent = new Date().getFullYear()
      addTopAnchors()
      addProjectAnchors(document)
      addDirectionsLinks(document)
      setupTelMailToTracking(document)
      setupTouchMenu()
      setupTouchDropdowns()
      setupQuizDialog()
      initGoogleAnalytics()
    },
    beforeLeave({ next }) {
      webflowPageId = extractWebflowPageId(next)
      removeTopAnchors()
      document.documentElement.setAttribute('data-loading', '')
      document.activeElement.blur()
      lenis.stop()
    },
    beforeEnter({ next }) {
      document.documentElement.setAttribute('data-wf-page', webflowPageId)
      startQuizPopupTimer(next)
    },
    enter({ next }) {
      preparePageTransition(next)
    },
    afterEnter({ next, current }) {
      reinitWebflow(next)
      setTimeout(() => { addTopAnchors() }, 0)
      return handlePageTransition(next, current)
    },
  }],
  views: [
    {
      namespace: 'home',
      beforeEnter({ next }) {
        initSliders(next)
        setupCloudflareStream(next)
        addDirectionsLinks(next.container)
      },
    },
    {
      namespace: 'meet-the-team',
      beforeEnter() {
      },
    },
    {
      namespace: 'our-story',
      beforeEnter() {
      },
    },
    {
      namespace: 'our-process',
      beforeEnter() {
      },
    },
    {
      namespace: 'blog',
      beforeEnter() {
      },
    },
    {
      namespace: 'blog-post',
      beforeEnter({ next }) {
        addDirectionsLinks(next.container)
        setupTelMailToTracking(next.container)
      },
    },
    {
      namespace: 'faq',
      beforeEnter({ next }) {
        initFaqFiltering(next)
        addDirectionsLinks(next.container)
        setupTelMailToTracking(next.container)
      },
    },
    {
      namespace: 'products',
      beforeEnter() {
      },
    },
    {
      namespace: 'product-roomvo',
      beforeEnter({ next }) {
        getRoomvoCatalog(next)
        lenis.options.prevent = () => true
      },
      beforeLeave() {
        lenis.options.prevent = () => false
      },
    },
    {
      namespace: 'product-custom',
      beforeEnter() {
      },
    },
    {
      namespace: 'projects',
      beforeEnter() {
        removeProjectAnchors()
      },
      beforeLeave({ current }) {
        addProjectAnchors(current.container)
      }
    },
    {
      namespace: 'gallery',
      beforeEnter({ next }) {
        initFancyapps(next)
      }
    },
    {
      namespace: 'testimonials',
      beforeEnter({ next }) {
        setupCloudflareStream(next)
      },
    },
    {
      namespace: 'reviews',
      beforeEnter() {
        getFeedspring()
      },
    },
    {
      namespace: 'inventory',
      beforeEnter({ next }) {
        initAgGrid(next)
      },
    },
    {
      namespace: 'request-an-estimate',
      beforeEnter({ next }) {
        initPhoneFormatter(next)
        initFormspark(next)
        setupTelMailToTracking(next.container)
      },
    },
    {
      namespace: 'quiz',
      beforeEnter({ next }) {
        initQuiz(next)
        initPhoneFormatter(next)
        initFormspark(next)
      },
    }
  ],
})


// webflow
let webflowPageId = null

const reinitWebflow = (next) => {
  const webflowPageId = extractWebflowPageId(next)
  document.documentElement.setAttribute('data-wf-page', webflowPageId)

  window.Webflow.destroy()
  window.Webflow.require?.('ix2')?.init()
}

const extractWebflowPageId = (next) => {
  const parser = new DOMParser()
  const dom = parser.parseFromString(next.html, 'text/html')
  return dom.documentElement.getAttribute('data-wf-page')
}


// lenis
const lenis = new Lenis({
  duration: 1.1,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  orientation: 'vertical',
  gestureOrientation: 'vertical',
  smoothWheel: true,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
})

const raf = (time) => {
  lenis.raf(time)
  requestAnimationFrame(raf)
}


// google analytics
const initGoogleAnalytics = () => {
  return new Promise((r, error) => {
    const measurementId = 'G-399NF7K75G'
    const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    if (document.querySelector(`script[src="${scriptSrc}"]`)) { r(); return }
    const script = document.createElement('script')
    script.src = scriptSrc
    script.onload = () => {
      window.dataLayer = window.dataLayer || []
      function gtag() { dataLayer.push(arguments) }
      window.gtag = gtag
      gtag('js', new Date())
      gtag('config', `${measurementId}`, { send_page_view: false })
      r()
    }
    script.onerror = error
    document.head.appendChild(script)
  })
}

const trackGAEvent = (eventName, params = {}) => {
  if (!window.gtag) return
  window.gtag('event', eventName, params)
}

const setupTelMailToTracking = (scope = document) => {
  scope.querySelectorAll('a[href^="tel:"]').forEach(link => {
    link.addEventListener('click', () => {
      trackGAEvent('tel_click')
    })
  })

  scope.querySelectorAll('a[href^="mailto:"]').forEach(link => {
    link.addEventListener('click', () => {
      trackGAEvent('mailto_click')
    })
  })
}


// formspark
const initFormspark = (next) => {
  $('form[action^="https://submit-form.com"]', next.container).each((i, el) => {
    const form = $(el)

    form.submit((e) => {
      e.preventDefault()
      const botpoison = new Botpoison({ publicKey: 'pk_72990c95-838a-4eea-bcdf-9fed629a8237' })

      const setupSubmitBtn = (disabled) => {
        const submitBtn = form.find('button[type="submit"]')[0]

        submitBtn.querySelectorAll('span').forEach(span => {
          span.textContent = disabled ? submitBtn.getAttribute('data-wait') : 'Submit'
        })
        submitBtn.disabled = disabled
      }; setupSubmitBtn(true)

      botpoison
        .challenge()
        .then(result => {
          let data = form.serialize()
          data += '&_botpoison=' + result.solution
          $.ajax({
            url: form.attr('action'),
            method: 'POST',
            data,
            dataType: 'json',
            success: () => {
              const parent = form.parent()
              parent.children('form').hide()
              parent.children('.w-form-done').show()

              trackGAEvent('form_submit', { form_id: form.attr('id') })
            },
            error: () => form.parent().find('.w-form-fail').show(),
            complete: () => {
              setupSubmitBtn(false)
            }
          })
        })
        .catch(() => {
          form.parent().find('.w-form-fail').show()
          setupSubmitBtn(false)
        })
    })
  })
}


// fancyapps
const initFancyapps = (next) => {
  const carouselElement = next.container.querySelector('.f-carousel')

  const carousel = new Carousel(carouselElement, {
    transition: 'crossfade',
    Dots: false,
    Navigation: {
      classes: {
        button: 'btn--slider',
      },
      prevTpl: '<svg viewBox="0 0 8 14" class="icon--chev"><path fill="currentColor" d="M7.86 12.6L6.46 14L5.76 13.3L0 7.56V6.46L6.46 0L7.86 1.4L2.25 7L7.85 12.6H7.86Z"></path></svg>',
      nextTpl: '<svg viewBox="0 0 8 14" class="icon--chev"><path fill="currentColor" d="M0 1.4L1.4 0L2.1 0.7L7.86 6.44V7.54L1.4 14L0 12.6L5.61 7L0.00999975 1.4H0Z"></path></svg>',
    },
    on: {
      init: (instance) => {

        document.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            instance.slidePrev()
          } else if (e.key === 'ArrowRight') {
            instance.slideNext()
          }
        })
      }
    }
  }, { Thumbs })
}


// feedspring
const getFeedspring = () => {
  if (!window.feedspringWidget) {
    fetch('https://scripts.feedspring.com/google-reviews-attrs.js')
      .then((response) => response.text())
      .then((scriptContent) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.text = scriptContent
        document.head.appendChild(script)

        const initializationCheck = setInterval(() => {
          if (window.feedspringWidget) {
            window.feedspringWidget.initialize()
            clearInterval(initializationCheck)
          }
        }, 50)
      })
      .catch((error) => {
        console.error('Feedspring initialization failed:', error)
      })
  } else {
    window.feedspringWidget.initialize()
  }
}


// roomvo
const getRoomvoCatalog = (next) => {
  const filterParam = next.container.querySelector('[data-filter-param]').dataset.filterParam
  const currentUrl = new URL(window.location.href)
  const baseUrl = currentUrl.origin + currentUrl.pathname
  history.replaceState(null, '', baseUrl + filterParam)

  new Promise((resolve, reject) => {
    const scriptUrl = 'https://www.roomvo.com/static/scripts/b2b/common/assistant.js'
    const attributes = {
      id: 'roomvoAssistant',
      type: 'text/javascript',
      'data-locale': 'en-us',
      'data-position': 'bottom-right'
    }
    if (document.querySelector(`script[src="${scriptUrl}"]`) || document.querySelector(`#${attributes.id}`)) {
      resolve()
    } else {
      const script = document.createElement('script')
      script.src = scriptUrl
      Object.entries(attributes).forEach(([key, value]) => script.setAttribute(key, value))
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    }
  }).then(() =>
    new Promise((resolve, reject) => {
      const maxRetries = 50
      let retryCount = 0
      const intervalId = setInterval(() => {
        try {
          window._roomvo.whiteriverflooring.addProductCatalog()
          const catalogEl = next.container.querySelector('#roomvoCatalog')
          if (catalogEl.innerHTML.trim() !== "") {
            const currentUrl = new URL(window.location.href)
            const baseUrl = currentUrl.origin + currentUrl.pathname
            if (currentUrl.search === filterParam) {
              history.replaceState(null, '', baseUrl)
            }
            clearInterval(intervalId)
            resolve()
          }
        } catch (error) {
          retryCount++
          if (retryCount >= maxRetries) {
            clearInterval(intervalId)
            reject(new Error('Roomvo catalog did not load within the expected time.'))
          }
        }
      }, 100)
    })
  )
}


// cloudflare
const setupCloudflareStream = (next) => {
  const playerInstances = []
  const players = next.container.querySelectorAll('.stream-player')

  players.forEach(playerEl => {
    const player = Stream(playerEl)
    player.controls = false
    playerEl.player = player
    playerInstances.push(player)

    playerEl.closest('.btn--media').addEventListener('click', () => {
      playerEl.parentElement.nextElementSibling.style.opacity = '0'
      playerEl.style.pointerEvents = 'auto'
      player.controls = true
      player.play()
    })
  })

  if (next.namespace === 'home') {
    next.container.querySelectorAll('.testimonials--home button[data-slider]').forEach(btn => {
      btn.addEventListener('click', () => {
        playerInstances.forEach(player => {
          player.pause()
        })
      })
    })
  }

  if (next.namespace === 'testimonials') {
    next.container.querySelectorAll('[data-play-btn]').forEach(btn => {
      btn.isPlaying = false
      btn.addEventListener('click', () => {
        const playerEl = btn.closest('.block-item__content').querySelector('.stream-player')
        playerEl.parentElement.nextElementSibling.style.opacity = '0'
        playerEl.style.pointerEvents = 'auto'
        playerEl.player.controls = true

        if (btn.isPlaying) {
          playerEl.player.pause()
          btn.querySelectorAll('span').forEach(span => {
            span.textContent = 'Play Video Testimonial'
          })
          btn.isPlaying = false
        } else {
          playerEl.player.play()
          btn.querySelectorAll('span').forEach(span => {
            span.textContent = 'Pause Video Testimonial'
          })
          btn.isPlaying = true
        }
      })
    })
  }
}


// ag grid
let gridApi

const initAgGrid = (next) => {
  fetch('/inventory/data.json')
    .then(res => res.json())
    .then(inventoryData => {
      window.INVENTORY_DATA = inventoryData
      const filteredData = inventoryData.filter(item => Number(item.amount_available) > 0);

      const gridOptions = {
        rowData: filteredData,
        columnDefs: [
          {
            field: 'product_type',
            headerName: 'Product Type',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            sortable: true,
            sortingOrder: ['asc', 'desc', null],
            width: 250,
            cellRenderer: (params) => {
              const imgUrl = params.data?.image_url
              const name = params.value || ''
              return `
                <div class="ag-img">
                  ${imgUrl ? `<img src="${imgUrl}" alt="${name}"/>` : ''}
                  <span>${name}</span>
                </div>
              `
            }
          },
          {
            field: 'manufacturer',
            headerName: 'Manufacturer',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 230
          },
          {
            field: 'style',
            headerName: 'Style',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 230
          },
          {
            field: 'color',
            headerName: 'Color',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 160
          },
          {
            field: 'product',
            headerName: 'Product',
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'notContains', 'equals'],
              defaultOption: 'contains',
            },
            width: 180
          },
          {
            field: 'amount_available',
            headerName: 'Amount Available',
            sortable: true,
            sort: 'desc',
            width: 183
          },
          {
            field: 'price',
            headerName: 'Price',
            sortable: true,
            sortingOrder: ['asc', 'desc', null],
            filter: 'agNumberColumnFilter',
            filterParams: {
              filterOptions: ['inRange', 'greaterThan', 'lessThan'],
              defaultOption: 'inRange',
              allowedCharPattern: '\\d\\,\\.',
              numberParser: text => {
                return text == null ? null : parseFloat(text.replace(',', '.'));
              },
              numberFormatter: value => {
                return value == null ? null : value.toString().replace('.', ',');
              }
            },
            width: 160,
            valueFormatter: params => {
              const price = params.value != null ? params.value.toFixed(2) : '';
              const uom = params.data?.uom ?? '';
              const separator = uom === 'Each' ? ' ' : '/';
              return `$${price}${uom ? separator + uom : ''}`;
            }
          },
          // {
          //   field: 'bin',
          //   headerName: 'Bin',
          //   width: 100
          // },
          // {
          //   field: 'sku',
          //   headerName: 'SKU',
          //   width: 180,
          //   filter: 'agTextColumnFilter',
          //   filterParams: {
          //     filterOptions: ['contains', 'equals'],
          //     defaultOption: 'contains',
          //   }
          // },
        ],
        defaultColDef: {
          editable: false,
          sortable: false,
          resizable: true,
          sortingOrder: ['desc', 'asc', null],
        },
        rowHeight: 120,
        onGridReady(event) {
          window.inventoryGridApi = event.api;
          initProductTypeFilter(event.api);
        },
      }

      gridApi = createGrid(next.container.querySelector('.ag-grid'), gridOptions)

      next.container.querySelector('.input--search').addEventListener('input', (e) => {
        gridApi.setGridOption('quickFilterText', e.target.value)
      })

      const scrollWrap = next.container.querySelector('.ag-grid__filters-scroll')

      const leftBtn = next.container.querySelector('[data-ag-btn-prev]')
      const rightBtn = next.container.querySelector('[data-ag-btn-next]')

      const updateScrollButtons = () => {
        const maxScroll = scrollWrap.scrollWidth - scrollWrap.clientWidth - 68

        leftBtn.classList.toggle('is-hidden', scrollWrap.scrollLeft <= 0)
        rightBtn.classList.toggle('is-hidden', scrollWrap.scrollLeft >= maxScroll - 1)
      }

      updateScrollButtons()
      scrollWrap.addEventListener('scroll', updateScrollButtons)

      leftBtn.addEventListener('click', () => {
        scrollWrap.scrollBy({ left: -160, behavior: 'smooth' })
        setTimeout(updateScrollButtons, 200)
      })
      
      rightBtn.addEventListener('click', () => {
        scrollWrap.scrollBy({ left: 160, behavior: 'smooth' })
        setTimeout(updateScrollButtons, 200)
      })
    })
}

const initProductTypeFilter = (api) => {
  document
    .querySelectorAll('input[name="product-type"]')
    .forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        const val = radio.value;

        if (val === 'all') {
          api.setFilterModel(null);
        } else {
          api.setFilterModel({
            product_type: { type: 'equals', filter: val }
          });
        }

        api.onFilterChanged();
      });
    });
}


// page transition
const preparePageTransition = (next) => {
  next.container.style.opacity = '0'
  void next.container.offsetHeight
}

const handlePageTransition = (next, current) => {
  return new Promise((resolve) => {
    const header = document.querySelector('.header')
    const headerBrand = document.querySelector('.header__brand')
    const headerLogo = headerBrand.querySelector('.link--logo')
    const brandHeight =
      headerBrand.getBoundingClientRect().height +
      parseFloat(getComputedStyle(headerBrand).marginBottom)
    const progress = Math.min((window.scrollY / brandHeight) * 100, 100)
    const anchor = window.__pendingHashScroll

    if (anchor) {
      history.pushState(null, '', `/projects${anchor}`)
    }

    if (!['quiz', 'gallery', 'inventory'].includes(next.namespace)) {
      positionHeader({
        header,
        brandHeight,
        headerLogo,
        progress,
        currentNamespace: current.namespace,
      })
    } else {
      const offset = brandHeight - calcHeaderOffset(brandHeight, progress)
      header.style.transition = 'transform var(--easing--norm)'
      header.style.transform = `translateY(-${offset}px)`
      headerLogo.style.transition = 'opacity var(--easing--norm)'
      headerLogo.style.opacity = 0
      void header.offsetHeight
    }

    next.container.style.position = 'fixed'
    next.container.style.opacity = '1'

    const onTransitionEnd = () => {
      requestAnimationFrame(() => {
        lenis.resize()

        lenis.scrollTo('top', {
          immediate: true,
          force: true,
          onComplete: () => {
            next.container.removeAttribute('style')
            header.removeAttribute('style')
            headerLogo.removeAttribute('style')
            document.documentElement.removeAttribute('data-loading')

            next.container.removeEventListener('transitionend', onTransitionEnd)
            resolve()

            if (anchor) {
              requestAnimationFrame(() => {
                document.querySelector(anchor).scrollIntoView({ behavior: 'smooth' })
                window.__pendingHashScroll = null
                lenis.start()
              })
            } else {
              lenis.start()
            }
          },
        })
      })
    }

    next.container.addEventListener('transitionend', onTransitionEnd)
  })
}


// header
const calcHeaderOffset = (brandHeight, progress) => {
  return (brandHeight * progress) / 100
}

const positionHeader = ({
  header,
  brandHeight,
  headerLogo,
  progress,
  currentNamespace,
}) => {

  if (progress > 0) {
    const offset = calcHeaderOffset(brandHeight, progress)
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = `translateY(${offset}px)`
    void header.offsetHeight
  }

  if (progress >= 100) {
    headerLogo.style.transform = 'translateY(var(--spacing--200))'
    void headerLogo.offsetHeight
  }

  if (['quiz', 'gallery', 'inventory'].includes(currentNamespace)) {
    header.style.transition = 'none'
    header.style.transform = `translateY(calc(-1 * var(--header--brand) + var(--spacing--200)))`
    void header.offsetHeight
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = ''
    headerLogo.style.opacity = 1
  }
}

const setupTouchMenu = () => {
  const header = document.querySelector('.header')
  const headerBrand = header.querySelector('.header__brand')
  const headerNav = header.querySelector('.header__nav')
  const menuButton = header.querySelector('.btn--menu')
  const headerLogo = headerBrand.querySelector('.link--logo')
  let brandHeight =
    headerBrand.getBoundingClientRect().height +
    parseFloat(getComputedStyle(headerBrand).marginBottom)
  let progress = Math.min((window.scrollY / brandHeight) * 100, 100)
  let resizeTimeout

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 992 && (header.hasAttribute('open'))) {
        header.removeAttribute('open')
        header.style.transform = ''
        headerLogo.removeAttribute('style')
        lenis.start()
      } else {
        brandHeight =
          headerBrand.getBoundingClientRect().height +
          parseFloat(getComputedStyle(headerBrand).marginBottom)
        progress = Math.min((window.scrollY / brandHeight) * 100, 100)
      }
    }, 300)
  })

  menuButton.addEventListener('click', () => {
    header.toggleAttribute('open')
    headerNav.firstElementChild.toggleAttribute('data-lenis-prevent')
    progress = Math.min((window.scrollY / brandHeight) * 100, 100)

    if (header.hasAttribute('open')) {
      positionHeader({
        header,
        brandHeight,
        headerLogo,
        progress,
        currentNamespace: document.querySelector('[data-barba="container"]').dataset.namespace
      })

      lenis.stop()
    } else {
      header.style.transition = 'transform var(--easing--norm)'
      header.style.transform = ''
      lenis.start()

      if (progress >= 100) {
        headerLogo.style.transition = 'transform var(--easing--norm)'
        headerLogo.style.transform = 'translateY(calc(var(--spacing--200) - .625rem))'
        headerLogo.addEventListener('transitionend', () => {
          headerLogo.style = ''
        })
      }
    }
  })

  header.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 991 && (header.hasAttribute('open'))) {
        if (link === headerLogo || link.getAttribute('href').startsWith('/projects')) {
          closeTouchMenuComplete()
        } else {
          closeTouchMenuPartial()
        }
      }
    })
  })
}

const closeTouchMenuPartial = () => {
  const header = document.querySelector('.header')
  const headerBrand = header.querySelector('.header__brand')
  const headerLogo = headerBrand.querySelector('.link--logo')
  const brandHeight =
    headerBrand.getBoundingClientRect().height +
    parseFloat(getComputedStyle(headerBrand).marginBottom)
  const progress = Math.min((window.scrollY / brandHeight) * 100, 100)

  header.removeAttribute('open')
  header.querySelector('.nav__list').removeAttribute('data-lenis-prevent')

  if (progress >= 100) {
    headerLogo.style.transition = 'transform var(--easing--norm)'
    headerLogo.style.transform = 'translateY(calc(var(--spacing--200) - .625rem))'
    headerLogo.addEventListener('transitionend', () => {
      headerLogo.style = ''
    }, { once: true })
  }
}

const closeTouchMenuComplete = () => {
  if (window.innerWidth <= 991) {
    closeTouchMenuPartial()
    const header = document.querySelector('.header')
    header.style.transition = 'transform var(--easing--norm)'
    header.style.transform = ''
    lenis.start()
  }
}

const setupTouchDropdowns = () => {
  document.querySelectorAll('.btn--dropdown').forEach(btn => {
    btn.addEventListener('click', () => {
      const dropdown = btn.nextElementSibling

      document.querySelectorAll('.btn--dropdown + *').forEach(el => {
        el.style.height = el === dropdown && !el.style.height ? el.scrollHeight + 'px' : ''
      })
    })
  })
}


// anchor links
const addTopAnchors = () => {
  const currentUrl = new URL(window.location.href)
  const currentPath = currentUrl.pathname.replace(/\/$/, '')

  document.querySelectorAll('a').forEach(btn => {
    const btnHref = btn.getAttribute('href')
    const btnUrl = new URL(btnHref, window.location.href)
    const btnPath = btnUrl.pathname.replace(/\/$/, '')
    if (
      btnUrl.origin === window.location.origin &&
      btnPath === currentPath &&
      !btnUrl.hash
    ) {
      if (!btn.hasAttribute('data-href')) {
        btn.setAttribute('data-href', btnHref)
      }
      btn.setAttribute('href', '#top')
    }
  })
}

const removeTopAnchors = () => {
  document.querySelectorAll('a[href="#top"]').forEach(btn => {
    btn.setAttribute('href', btn.getAttribute('data-href'))
    btn.removeAttribute('data-href')
  })
}

const addProjectAnchors = (scope = document) => {
  if (scope === document && document.querySelector('[data-barba-namespace="projects"]')) {
    return
  }

  document.querySelectorAll('a[href^="/projects"][href*="#"]:not([href$="#top"])').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      const href = anchor.getAttribute('href')
      const [_, rawHash] = href.split('#')
      if (!rawHash) return

      window.__pendingHashScroll = `#${rawHash}`
      barba.go('/projects')

      closeTouchMenuComplete()
    })
  })
}

const removeProjectAnchors = () => {
  document.querySelectorAll('a[href^="/projects"][href*="#"]:not([href$="#top"])').forEach((anchor) => {
    const newAnchor = anchor.cloneNode(true)
    anchor.replaceWith(newAnchor)

    newAnchor.addEventListener('click', () => {
      closeTouchMenuComplete()
    })
  })
}


// directions links
const addDirectionsLinks = (scope = document) => {
  const isAppleDevice = () => /Mac|iPad|iPhone|iPod/.test(navigator.userAgent)
  const appleMapsURL = 'https://maps.apple.com/?address=800%20S%20Main%20St,%20Searcy,%20AR%20%2072143,%20United%20States&auid=7131026317242709025&ll=35.241869,-91.735784&lsp=9902&q=White%20River%20Flooring%20Inc&t=m'
  const googleMapsURL = 'https://maps.app.goo.gl/kzHLsURgSZSL569H6'

  scope.querySelectorAll('a[href="#get-directions"]').forEach(link => {
    link.setAttribute('href', isAppleDevice() ? appleMapsURL : googleMapsURL)
    link.addEventListener('click', () => {
      trackGAEvent('directions_click')
    })
  })
}


// sliders
const initSliders = (next) => {
  next.container.querySelectorAll('[data-slider="container"]').forEach(slider => {
    const slides = Array.from(slider.querySelector('[data-slider="list"]').children)
    const pgnBtns = Array.from(slider.querySelectorAll('.btn--pgn'))
    const prev = slider.querySelector('[data-slider="prev"]')
    const next = slider.querySelector('[data-slider="next"]')

    let current = slides.findIndex(slide => slide.getAttribute('data-slider') === 'active')
    current = current === -1 ? 0 : current

    const update = newIndex => {
      current = (newIndex + slides.length) % slides.length

      slides.forEach((slide, index) =>
        slide.setAttribute('data-slider', index === current ? 'active' : '')
      )
      pgnBtns.forEach((btn, index) => {
        btn.setAttribute('data-slider', index === current ? 'index' : '')
        btn.setAttribute('tabindex', index === current ? '-1' : '0')
      })
    }

    prev.addEventListener('click', () => update(current - 1))
    next.addEventListener('click', () => update(current + 1))
    pgnBtns.forEach((btn, index) =>
      btn.addEventListener('click', () => update(index))
    )

    update(current)
  })
}


// faq
const initFaqFiltering = (next) => {
  const faqNav = next.container.querySelector('.faq__nav')
  if (!faqNav) return
  const faqFiltersList = faqNav.querySelector('.nav__filters-list')
  const faqRadios = faqNav.querySelectorAll('input[name="filter"]')
  const faqItems = next.container.querySelectorAll('.faq__list--item')
  if (!faqFiltersList || !faqRadios.length || !faqItems.length) return

  const updateNavBtnBg = radio => {
    requestAnimationFrame(() => {
      const { width, height, top, left } = faqNav.querySelector(`label[for="${radio.id}"]`).getBoundingClientRect()
      const navRect = faqNav.getBoundingClientRect()
      faqFiltersList.style.setProperty('--btn-width', `${width}px`)
      faqFiltersList.style.setProperty('--btn-height', `${height}px`)
      faqFiltersList.style.setProperty('--btn-top', `${top - navRect.top}px`)
      faqFiltersList.style.setProperty('--btn-left', `${left - navRect.left}px`)
    })
  }

  const updateFaqItems = radio => {
    faqItems.forEach(item => {
      const match = item.getAttribute('data-match').includes(radio.id)
      item.toggleAttribute('data-active', match)
      item.toggleAttribute('inert', !match)
    })
  }

  const handleRadioChange = radio => {
    updateNavBtnBg(radio)
  }

  const params = new URLSearchParams(window.location.search)
  const filterValue = params.get('view') || 'all'
  const targetRadio = Array.from(faqRadios).find(r => r.id === filterValue) || faqRadios[0]
  targetRadio.checked = true
  handleRadioChange(targetRadio)
  updateFaqItems(targetRadio)

  faqRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      handleRadioChange(radio)
      if (window.innerWidth > 479) {
        lenis.scrollTo(next.container.querySelector('.anchor--faq'), {
          onComplete: () => {
            updateFaqItems(radio)
          }
        })
      } else {
        updateFaqItems(radio)
      }
      const newParams = new URLSearchParams(window.location.search)
      newParams.set('view', radio.id)
      window.history.pushState({}, '', `${window.location.pathname}?${newParams.toString()}`)
    })
  })

  const faqFiltersObserver = new ResizeObserver(() => {
    const checked = Array.from(faqRadios).find(r => r.checked)
    handleRadioChange(checked)
  })
  faqFiltersObserver.observe(document.documentElement)
}


// phone input formatter
const initPhoneFormatter = (next) => {
  const formatPhone = (value) => {
    let phone = value.replace(/[^\d()\-x]/g, '')
    const numbersOnly = phone.replace(/[^\d]/g, '')
    const maxLength = 10

    if (numbersOnly.length === 0) return ''
    if (numbersOnly.length <= 3) return numbersOnly
    if (numbersOnly.length <= 6) return `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3)}`

    const formattedNumber = `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(3, 6)}-${numbersOnly.slice(6, maxLength)}`

    if (phone.includes('x')) {
      let extension = phone.split('x')[1] || ''
      extension = extension.slice(0, 4)
      return `${formattedNumber} x${extension}`
    }

    return formattedNumber
  }

  const phoneInput = next.container.querySelector('input[type="tel"]')

  if (phoneInput) {
    phoneInput.addEventListener('input', (e) => {
      const currentValue = e.target.value
      const numbersOnly = currentValue.replace(/[^\d]/g, '')

      if (numbersOnly.length < 10 && currentValue.includes('x')) {
        phoneInput.value = currentValue.replace('x', '')
      } else {
        phoneInput.value = formatPhone(currentValue)
      }
    })
  }
}


// quizzes
const setupQuizDialog = () => {
  const dialog = document.querySelector('dialog.quiz')
  const openDialogBtns = document.querySelectorAll('[data-dialog-btn="open"]')
  const closeDialogBtn = dialog.querySelector('[data-dialog-btn="close"]')

  openDialogBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      lenis.stop()
      dialog.showModal()
      dialog.removeAttribute('inert')
    })
  })

  const closeDialog = () => {
    dialog.setAttribute('closing', '')
    dialog.setAttribute('inert', '')

    dialog.addEventListener('transitionend', () => {
      dialog.close()
      dialog.removeAttribute('closing')
      lenis.start()
    }, { once: true })
  }

  closeDialogBtn.addEventListener('click', closeDialog)

  document.querySelectorAll('.btn--quiz').forEach(btn => {
    btn.addEventListener('click', closeDialog)
  })

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog()
  })

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault()
    closeDialog()
  })
}

const startQuizPopupTimer = (next) => {
  if (next.namespace === 'quiz') {
    localStorage.setItem('quizLastShown', Date.now().toString())
    return
  }

  const cooldown = 3 * 24 * 60 * 60 * 1000
  const lastShown = localStorage.getItem('quizLastShown')
  const canShow = !lastShown || (Date.now() - parseInt(lastShown, 10) > cooldown)
  if (!canShow) return

  if (sessionStorage.getItem('quizScheduled') === 'true') return
  sessionStorage.setItem('quizScheduled', 'true')

  setTimeout(() => {
    const dialog = document.querySelector('dialog.quiz')
    if (!dialog) return
    lenis.stop()
    dialog.showModal()
    dialog.removeAttribute('inert')
    localStorage.setItem('quizLastShown', Date.now().toString())
  }, 30000)
}

const initQuiz = (next) => {
  const quizContainer = next.container.querySelector('.quiz__form')
  const steps = quizContainer.querySelectorAll('.form__step')
  let currentStepIndex = 0
  let currentStep = steps[currentStepIndex]
  const totalSteps = steps.length

  // show specific step
  const showStep = (index) => {
    currentStepIndex = index
    currentStep = steps[currentStepIndex]

    steps.forEach((step, i) => {
      if (i === index) {
        step.setAttribute('data-active', '')
      } else {
        step.removeAttribute('data-active')
      }
    })

    updateTabIndexes()
    updateProgressIndicator(index, totalSteps)
    updateContinueBtn()

    requestAnimationFrame(() => {
      currentStep.querySelector('a, button, input')?.focus()
    })

    // if final step, initialize input states
    if (currentStepIndex === totalSteps - 1) {
      updateInputStates()
    }

    addInputKeydownListeners()
  }

  // update tabindex and disabled state
  const updateTabIndexes = () => {
    steps.forEach((step, index) => {
      const inputs = step.querySelectorAll('input, button')

      if (index === currentStepIndex) {
        inputs.forEach((input) => {
          input.tabIndex = 0
        })
      } else {
        inputs.forEach((input) => {
          if (input.closest('.custom-input')) {
            if (input.value.trim() === '') {
              input.tabIndex = -1
              input.disabled = true
            } else {
              input.tabIndex = -1
              input.disabled = false
            }
          } else {
            input.tabIndex = -1
            input.disabled = false
          }
        })
      }
    })
  }

  // clear and uncheck step
  const clearAndUncheckStep = (step) => {
    const inputs = step.querySelectorAll('input')

    inputs.forEach((input) => {
      if (input.type === 'submit') {
        input.disabled = true
      } else if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false


        const event = new Event('change', { bubbles: true })
        input.dispatchEvent(event)

        const quizWrapper = input.closest('.input--quiz-wrap')
        if (quizWrapper) {
          const checkedElement = quizWrapper.querySelector('.w--redirected-checked')
          if (checkedElement) {
            checkedElement.classList.remove('w--redirected-checked')
          }
        }

        if (input.id === 'Agree-to-Receive-Communications') {
          const checkboxSvg = input.closest('.w-checkbox').querySelector('.w-checkbox-input')
          if (checkboxSvg) {
            checkboxSvg.classList.remove('w--redirected-checked')
          }
        }
      } else {
        input.value = ''

      }

      if (input.closest('.input--quiz-custom')) {

        input.value = ''
      }
    })
  }

  // move to next step
  const nextStep = () => {
    if (currentStepIndex < steps.length - 1) {
      showStep(currentStepIndex + 1)
    }
  }

  // move to previous step
  const prevStep = () => {
    if (currentStepIndex > 0) {
      clearAndUncheckStep(steps[currentStepIndex])
      clearAndUncheckStep(steps[currentStepIndex - 1])
      showStep(currentStepIndex - 1)
    }
  }

  // add keydown events
  const addInputKeydownListeners = () => {
    const inputs = currentStep.querySelectorAll('input[type="radio"], input[type="checkbox"]')

    inputs.forEach((input) => {
      input.removeEventListener('keydown', handleInputKeydown)
      input.addEventListener('keydown', handleInputKeydown)
    })
  }

  // keydown events
  const handleInputKeydown = (event) => {
    const target = event.target

    if (target.type === 'radio') {
      const name = target.name
      const radioButtons = Array.from(currentStep.querySelectorAll(`input[type="radio"][name="${name}"]`))
      const index = radioButtons.indexOf(target)

      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) {
        event.preventDefault()
        const prevIndex = (index - 1 + radioButtons.length) % radioButtons.length
        radioButtons[prevIndex].focus()
      } else if (['ArrowRight', 'ArrowDown'].includes(event.key)) {
        event.preventDefault()
        const nextIndex = (index + 1) % radioButtons.length
        radioButtons[nextIndex].focus()
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault()
        target.checked = true
        const changeEvent = new Event('change', { bubbles: true })
        target.dispatchEvent(changeEvent)
      } else if (event.key === 'Tab') {
        if (!event.shiftKey && index < radioButtons.length - 1) {
          event.preventDefault()
          const nextIndex = index + 1
          radioButtons[nextIndex].focus()
        } else if (event.shiftKey && index > 0) {
          event.preventDefault()
          const prevIndex = index - 1
          radioButtons[prevIndex].focus()
        } else if (!event.shiftKey && index === radioButtons.length - 1) {
          return
        } else if (event.shiftKey && index === 0) {
          return
        }
      }
    }

    // checkboxes
    else if (target.type === 'checkbox') {
      const checkboxes = Array.from(currentStep.querySelectorAll('input[type="checkbox"]'))
      const index = checkboxes.indexOf(target)

      if (['ArrowLeft', 'ArrowUp'].includes(event.key)) {
        event.preventDefault()
        const prevIndex = (index - 1 + checkboxes.length) % checkboxes.length
        checkboxes[prevIndex].focus()
      } else if (['ArrowRight', 'ArrowDown'].includes(event.key)) {
        event.preventDefault()
        const nextIndex = (index + 1) % checkboxes.length
        checkboxes[nextIndex].focus()
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        target.checked = !target.checked

        const changeEvent = new Event('change', { bubbles: true })
        target.dispatchEvent(changeEvent)
      }
    }
  }

  // back button logic
  const btnBack = quizContainer.querySelector('.btn--back')

  btnBack.addEventListener('click', prevStep)
  btnBack.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      prevStep()
    }
  })

  // progress indicator
  const updateProgressIndicator = (currentStepIndex, totalSteps) => {
    const totalStates = totalSteps - 1
    const clippedPercentage = 100 - (currentStepIndex * (100 / totalStates))
    quizContainer.querySelector('.progress-pgn').style.setProperty('--quiz-pgn', `${clippedPercentage}%`)
  }

  // update continue button state
  const updateContinueBtn = () => {
    const checkboxes = currentStep.querySelectorAll('input[type="checkbox"], input[type="radio"]')
    const customInputs = currentStep.querySelectorAll('.input--quiz-custom .input')

    const isAnyCheckboxChecked = Array.from(checkboxes).some((checkbox) => checkbox.checked)

    const isCustomBtnChecked = Array.from(customInputs).some((input) => {
      const parentBtn = input.closest('.input--quiz-custom')?.querySelector('input')
      return parentBtn?.checked
    })

    const allCustomInputsFilled = Array.from(customInputs).every((input) => {
      const parentBtn = input.closest('.input--quiz-custom')?.querySelector('input')
      return !parentBtn?.checked || (parentBtn.checked && input.value.trim() !== '')
    })

    const btnContinue = currentStep.querySelector('.btn--continue')
    if (btnContinue) {
      if (isCustomBtnChecked && !allCustomInputsFilled) {
        btnContinue.disabled = true
      } else {
        btnContinue.disabled = !(isAnyCheckboxChecked && allCustomInputsFilled)
      }
    }
  }


  // update input disabled states on final step
  const updateInputStates = () => {
    const emailPreference = document.getElementById('email-preference')
    const textPreference = document.getElementById('text-preference')
    const nameInput = document.getElementById('name')
    const emailInput = document.getElementById('email')
    const phoneInput = document.getElementById('phone')

    const isEmailSelected = emailPreference.checked
    const isTextSelected = textPreference.checked

    emailInput.disabled = !isEmailSelected
    phoneInput.disabled = !isTextSelected

    const shouldEnableName = isEmailSelected || isTextSelected
    nameInput.disabled = !shouldEnableName
  }


  // checkbox/radio change event delegation
  quizContainer.addEventListener('change', (event) => {
    const target = event.target

    // handle custom buttons with input fields
    if (target.matches('.input--quiz-custom input[type="radio"], .input--quiz-custom input[type="checkbox"]')) {
      const quizOptionContainer = target.closest('.input--quiz-custom')
      const customInputField = quizOptionContainer.querySelector('.input')
      if (target.checked) {
        if (customInputField) {
          customInputField.disabled = false
          setTimeout(() => {
            customInputField.focus()
          }, 0)
        }
      } else {
        if (customInputField) {
          customInputField.value = ''
          customInputField.disabled = true
        }
      }
      updateContinueBtn()
    }

    // handle regular radio buttons for auto skip
    else if (target.matches('.quiz-options input[type="radio"]:not(#email-preference):not(#text-preference):not(.input--quiz-custom input[type="radio"])')) {
      if (target.checked) {
        setTimeout(nextStep, 400)
      }
    }

    // regular checkboxes
    else if (target.matches('.quiz-options input[type="checkbox"]:not(.input--quiz-custom input[type="checkbox"])')) {
      updateContinueBtn()
    }

    // handle final step radio buttons
    else if (target.matches('#email-preference, #text-preference')) {
      updateInputStates()
    }
  })

  // input events
  quizContainer.addEventListener('input', (event) => {
    const target = event.target

    if (target.matches('.input--quiz-custom .input')) {
      updateContinueBtn()
    }
  })

  // continue button logic using event delegation
  quizContainer.addEventListener('click', (event) => {
    const btnContinue = event.target.closest('.btn--continue')

    if (btnContinue && quizContainer.contains(btnContinue)) {
      event.preventDefault()
      nextStep()
    }
  })

  showStep(currentStepIndex)
}


// credit
console.log('%cDesign & Dev by Johnny Zimmer — https://johnnyzimmer.com', 'background-color: #000; color: #fff; font-size:10px; padding:8px 10px 6px; border-radius:4px')